import { type OpenApiSchemaSimilarCardsCreateCommand } from '#shared/api/schema';
import {
    ADDITIONAL_PRODUCTS_MANUAL_MODE,
    ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE,
    ADDITIONAL_PRODUCTS_SOURCE_MODE,
    type AdditionalProductsFormValue,
} from './constants';

export type AdditionalProductsSavePayload =
    | { type: typeof ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE.AI }
    | {
          type: typeof ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE.MANUAL;
          payload: OpenApiSchemaSimilarCardsCreateCommand;
      };

function mapBinding(formValue: AdditionalProductsFormValue): OpenApiSchemaSimilarCardsCreateCommand['binding'] {
    const { manualMode, binding } = formValue;

    if (manualMode === ADDITIONAL_PRODUCTS_MANUAL_MODE.ALL) {
        return {};
    }

    if (manualMode === ADDITIONAL_PRODUCTS_MANUAL_MODE.SELECTED) {
        return {
            product_list_id: binding.productListId,
        };
    }

    return {
        category_ids: binding.categoryIds,
        collection_ids: binding.collectionIds,
    };
}

export function mapFormStateToPutPayload(formValue: AdditionalProductsFormValue): AdditionalProductsSavePayload {
    if (formValue.sourceMode === ADDITIONAL_PRODUCTS_SOURCE_MODE.AI) {
        return { type: ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE.AI };
    }

    return {
        type: ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE.MANUAL,
        payload: {
            binding_mode: formValue.manualMode,
            binding: mapBinding(formValue),
        },
    };
}

export function mapFormStateToSimilarCardsSettings(
    formValue: AdditionalProductsFormValue
): OpenApiSchemaSimilarCardsCreateCommand | null {
    const savePayload = mapFormStateToPutPayload(formValue);

    if (savePayload.type === ADDITIONAL_PRODUCTS_SAVE_PAYLOAD_TYPE.AI) {
        return null;
    }

    return savePayload.payload;
}
